export const testId = {
  login: {
    emailInput: 'login-email-input',
    passwordInput: 'login-password-input',
    continueButton: 'login-continue-button',
  },
  signup: {
    emailInput: 'signup-email-input',
    passwordInput: 'signup-password-input',
    continueButton: 'signup-continue-button',
  },
  navigation: {
    sideNav: {
      home: 'home',
      messages: 'messages',
      analytics: 'analytics',
      automations: 'automations',
      processes: 'processes',
      inboxes: 'inboxes',
      models: 'models',
      integrations: 'integrations',
      support: 'support',
      feedback: 'feedback',
      settings: 'settings',
    },
  },
  dashboard: {
    heading: 'dashboard-heading',
  },
  settings: {
    navigation: {
      account: 'settings-account',
      organization: 'settings-organization',
      users: 'settings-users',
      security: 'settings-security',
      apiKeys: 'settings-apikeys',
    },
    apiKeys: {
      searchInput: 'settings-apikeys-search-input',
    },
    account: {
      nameInput: 'settings-account-name-input',
    },
    users: {
      searchInput: 'settings-users-search-input',
      filtersButton: 'settings-users-filters-button',
      newUserButton: 'settings-users-new-user-button',
      inviteModal: {
        container: 'settings-users-invite-modal',
        emailInput: 'settings-users-invite-email-input',
        roleSelect: 'settings-users-invite-role-select',
        roleOption: (role: string) => `settings-users-invite-role-option-${role.toLowerCase()}`,
        cancelButton: 'settings-users-invite-cancel-button',
        inviteButton: 'settings-users-invite-button',
      },
      table: {
        container: 'settings-users-table-container',
        row: (email: string) => `settings-users-table-row-${email}`,
        emailCell: 'settings-users-table-email-cell',
        userGroupsCell: 'settings-users-table-user-groups-cell',
        roleCell: 'settings-users-table-role-cell',
        checkbox: 'settings-users-table-checkbox',
      },
      filters: {
        authentication: 'settings-users-filter-authentication',
        mfaEnabled: 'settings-users-filter-mfa-enabled',
        mfaDisabled: 'settings-users-filter-mfa-disabled',
        userGroups: 'settings-users-filter-user-groups',
        roles: 'settings-users-filter-roles',
        adminRole: 'settings-users-filter-admin-role',
      },
    },
  },
  automations: {
    navigation: {
      flows: 'automations-navigation-flows',
      customActions: 'automations-navigation-custom-actions',
    },
    overview: {
      emptyState: 'automations-overview-empty-state',
      noAutomationsText: 'automations-overview-no-automations-text',
      browseIntegrationsButton: 'automations-overview-browse-integrations-button',
    },
    flowEditor: {
      canvas: 'react-flow',
      controls: 'react-flow__controls',
      controlsZoomIn: 'react-flow__controls-zoomin',
      controlsZoomOut: 'react-flow__controls-zoomout',
      controlsFitView: 'react-flow__controls-fitview',
      node: (nodeId: string) => `rf__node-${nodeId}`,
      edge: (edgeId: string) => `rf__edge-${edgeId}`,
      newNodeSideBar: 'new-node-side-bar',
      newNodeSideBarSearch: 'new-node-side-bar-search-field',
      conditionsAccordion: 'new-node-side-bar-conditions-accordion-trigger',
      actionsAccordion: 'new-node-side-bar-actions-accordion-trigger',
      appsAccordion: 'new-node-side-bar-apps-accordion-trigger',
      utilitiesAccordion: 'new-node-side-bar-utilities-accordion-trigger',
      newConditionButton: 'new-condition-node-button',
      newActionButton: 'new-action-node-button',
      newCodeStepButton: 'new-code-step-button',
      newUtilityButton: 'new-utility-node-button',
    },
    customActions: {
      overview: {
        emptyState: 'automations-custom-actions-overview-empty-state',
        emptySearchState: 'automations-custom-actions-overview-empty-search-state',
        search: 'automations-custom-actions-overview-search',
        row: 'automations-custom-actions-overview-row',
        deleteApp: 'automations-custom-actions-overview-delete-app',
        confirmDelete: 'automations-custom-actions-overview-confirm-delete',
      },
      create: {
        button: 'automations-custom-actions-create-button',
      },
      editor: {
        startFromScratch: 'automations-custom-actions-editor-start-from-scratch',
        navigationNameInput: 'automations-custom-actions-editor-navigation-name-input',
        arrowBack: 'automations-custom-actions-editor-arrow-back',
        publishButton: 'automations-custom-actions-editor-publish-button',
      },
    },
  },
  integrations: {
    table: {
      container: 'integrations-table-container',
      emptyState: 'integrations-table-empty-state',
      search: 'integrations-table-search',
      filtersButton: 'integrations-table-filters-button',
      connectButton: 'integrations-table-connect-button',
      bulkActions: 'integrations-table-bulk-actions',
      integrationCheckbox: 'integrations-table-checkbox',
    },
    browse: {
      search: 'integrations-browse-search',
      categoryFilter: 'integrations-browse-category-filter',
      integrationCard: 'integrations-browse-integration-card',
      integrationCardByType: (type: string) => `integrations-browse-integration-card-${type}`,
      connectButton: 'integrations-browse-connect-button',
    },
    setup: {
      stepCard: 'integrations-setup-step-card',
      continueButton: 'integrations-setup-continue-button',
      nextButton: 'integrations-setup-next-button',
      exploreButton: 'integrations-setup-explore-button',
      confirmCheckbox: 'integrations-setup-confirm-checkbox',
      s3ConnectionMethod: (method: string) => `integrations-setup-s3-method-${method}`,
    },
    sheet: {
      container: 'integrations-sheet-container',
      generalTab: 'integrations-sheet-general-tab',
      accessTab: 'integrations-sheet-access-tab',
      settingsTab: 'integrations-sheet-settings-tab',
      advancedTab: 'integrations-sheet-advanced-tab',
      deleteSection: 'integrations-sheet-delete-section',
      saveButton: 'integrations-sheet-save-button',
      closeButton: 'integrations-sheet-close-button',
    },
    bulkActions: {
      menu: 'integrations-bulk-actions-menu',
      addToGroup: 'integrations-bulk-actions-add-to-group',
      removeGroups: 'integrations-bulk-actions-remove-groups',
      checkConnection: 'integrations-bulk-actions-check-connection',
      editStatus: 'integrations-bulk-actions-edit-status',
      delete: 'integrations-bulk-actions-delete',
    },
  },
  floatingSheet: {
    deleteButton: 'floating-sheet-delete-button',
  },
  modals: {
    confirmButton: 'modal-confirm-button',
    cancelButton: 'modal-cancel-button',
    deleteConfirmButton: 'modal-delete-confirm-button',
  },
  relabeling: {
    modelBadgeNegative: 'model-badge-sentiment-negative',
    modelBadgePositive: 'model-badge-sentiment-positive',
    metaPanel: 'meta-panel',
    detailsButton: 'message-details-button',
    manuallySetTagButton: 'manually-set-tag-button',
    closeButton: 'details-close-button',
    positiveTagOption: 'tag-option-positive',
    negativeTagOption: 'tag-option-negative',
    messageFeed: 'message-feed',
    messageCard: 'message-card',
  },
  messages: {
    messageFeed: 'message-feed',
    messageCard: 'message-card',
    metaPanel: 'meta-panel',
    readingPanel: 'reading-panel',
    feedPanel: 'message-feed',
    searchFieldInput: 'message-search-field-input',
    searchAdvancedButton: 'message-search-advanced-button',
    searchThreadIdInput: 'message-search-threadid-input',
    searchSubmitButton: 'message-search-submit-button',
    searchClearButton: 'message-search-clear-button',
  },
  miniatureFeed: {
    container: 'miniature-message-feed',
    threadIdInput: 'input-threadidofthemessagetosimulate',
    threadIdSubmit: 'submit-threadidofthemessagetosimulate',
    inboxSelect: 'miniature-feed-inbox-select',
    inboxOption: (id: string) => `miniature-feed-inbox-option-${id}`,
    modelFilter: 'miniature-feed-model-filter',
    message: (threadId: string) => `miniature-feed-message-${threadId}`,
    forceSimulateSection: 'miniature-feed-force-simulate-section',
    forceSimulateButton: 'miniature-feed-force-simulate-button',
  },
  simulate: {
    dialogTrigger: 'simulate-dialog-trigger',
    dialogContent: 'simulate-dialog-content',
    selectButton: 'simulate-dialog-select-button',
    writeButton: 'simulate-dialog-write-button',
    stepMessage: 'simulate-dialog-step-message',
    stepMode: 'simulate-dialog-step-mode',
  },
} as const;
